import React from "react";
import styled from "styled-components";
import { device } from "../../helpers";

export const ContentWrapper = styled.div<TemplateContent>`
    display: flex;
    flex-direction: column;
    margin-top: 100px;
    width: 100%;

    @media ${device.phone} {
        margin-top: ${(p) => (p.isLandingPage ? 0 : 146)}px;
    } ;
`;

type TemplateContent = {
    isLandingPage?: boolean;
    children: JSX.Element | JSX.Element[];
};
export const Content = ({
    isLandingPage = false,
    children,
}: TemplateContent) => (
    <ContentWrapper isLandingPage={isLandingPage}>{children}</ContentWrapper>
);

export * from "./Header";
export * from "./LogoutLink";

export const Container = styled.div<{
    width?: string;
    margin?: string;
}>`
    display: flex;
    flex-direction: column;
    width: ${(p) => p.width || "80%"};
    margin: ${(p) => p.margin || "40px auto"};

    @media ${device.phone} {
        margin: 20px auto;
        width: 95%;
    } ;
`;
